import MerchantEvaluationProjectRankApi from '@/api/merchant-evaluation-project-rank'

/**
 * 评审系统 - 评审方案管理
 */

const state = {
}

const mutations = {
}

const actions = {
  async list ({ commit }, params) {
    const result = await MerchantEvaluationProjectRankApi.list(params)
    return result
  },
  async all ({ commit }, params) {
    const result = await MerchantEvaluationProjectRankApi.all(params)
    return result
  },
  async getById ({ commit }, id) {
    const result = await MerchantEvaluationProjectRankApi.getById(id)
    return result
  },
  async insert ({ commit }, data) {
    const result = await MerchantEvaluationProjectRankApi.insert(data)
    return result
  },
  async update ({ commit }, data) {
    const result = await MerchantEvaluationProjectRankApi.update(data)
    return result
  },
  async remove ({ commit }, id) {
    const result = await MerchantEvaluationProjectRankApi.remove(id)
    return result
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/merchant-evaluation-project-rank.js